import { useWhiteLabel } from "@/product/lib/WhiteLabelContext";
import "./SiteLineWordmark.css";

export const SITELINE_WORDMARK_SRC = "/brand/siteline-wordmark.png";

export type SiteLineWordmarkSize =
  | "hero"
  | "header"
  | "splash"
  | "card"
  | "inline"
  | "drawer";

interface SiteLineWordmarkProps {
  readonly size?: SiteLineWordmarkSize;
  readonly className?: string;
  readonly alt?: string;
}

export function SiteLineWordmark({
  size = "header",
  className,
  alt = "SiteLine",
}: SiteLineWordmarkProps) {
  let brandingLogo: string | null = null;
  let brandingName: string = "";

  try {
    const wl = useWhiteLabel();
    brandingLogo = wl.branding.logoUrl;
    brandingName = wl.branding.companyName;
  } catch {
    // Falls back gracefully if rendered outside WhiteLabelProvider (e.g. auth screen)
  }

  const classes = ["siteline-wordmark", `siteline-wordmark--${size}`, className]
    .filter(Boolean)
    .join(" ");

  if (brandingLogo) {
    return (
      <img
        src={brandingLogo}
        alt={brandingName || alt}
        className={classes}
        decoding="async"
      />
    );
  }

  if (brandingName) {
    return (
      <span
        className={`${classes} siteline-custom-brand-text`}
        style={{
          fontWeight: 700,
          letterSpacing: "-0.02em",
          display: "inline-flex",
          alignItems: "center",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          fontSize: size === "hero" ? "2rem" : size === "splash" ? "1.25rem" : "1.05rem",
          color: "inherit",
        }}
      >
        {brandingName}
      </span>
    );
  }

  return (
    <img
      src={SITELINE_WORDMARK_SRC}
      alt={alt}
      className={classes}
      decoding="async"
    />
  );
}
